import { createAction } from '@reduxjs/toolkit';

import { SagaPayload } from '../api.types';
import {
  CreateMemberRequest,
  CreateMemberResponse,
  FlagMemberAsPaidRequest,
  VerifyMemberStatusRequest
} from './external-registration.types';

export const requestFindActiveProgrammes = createAction('external-registration/findActiveProgrammes');

export const requestCreateMember = createAction<SagaPayload<CreateMemberRequest, CreateMemberResponse>['payload']>(
  'external-registration/createMember'
);

export const requestFlagMemberAsPaid = createAction<SagaPayload<FlagMemberAsPaidRequest>['payload']>(
  'external-registration/flagMemberAsPaid'
);

export const requestVerifyMemberStatus = createAction<SagaPayload<VerifyMemberStatusRequest>['payload']>(
  'external-registration/verifyMemberStatus'
);
